export const PAGE_NAME = "PAGE_NAME"
export const OPEN_LEAVE_MODEL = "OPEN_LEAVE_MODEL"


const init = {
  drawerOpen: false,
  openItem: [],
  page : "",
  openLeaveModuele:{
    open : false,
    id: null
  },
  openInterviewModule:{
    open : false,
    data: null
  },
  openArchivedModule: false
}

const menu = (state = init, action) => {
  switch (action.type) {
    case "UPDATE_MENU_ACTION": {
      return {
        ...state,
        ...(action.payload || {})
      }
    }
    case "SEND_NOTIFICATION_ACTION": {
      return {
        ...state,
        ...(action.payload || {})
      }
    }
    case "PAGE_NAME" : {
      return {
        ...state,
        page : action.payload
      }
    }
    case "OPEN_LEAVE_MODEL" : {
      return {
        ...state,
        openLeaveModuele : {
          open : action.payload.open,
          id : action.payload.id
        }
      }
    }
    case "OPEN_INTERVIEW_MODEL" : {
      return {
        ...state,
        openInterviewModule : {
          open : action.payload.open,
          data : action.payload.id
        }
      }
    }
    case "OPEN_ARCHIVED_MODEL" : {
      return {
        ...state,
        openArchivedModule :  action.payload
      }
    }
    default:
      return state
  }
};

export default menu;